import { z } from 'zod'

export const AreaSummary = z.object({
  id: z.string(),
  name: z.string(),
  subArea: z
    .object({
      id: z.string(),
      name: z.string(),
      isGeneric: z.boolean()
    })
    .array()
})
export type AreaSummary = z.infer<typeof AreaSummary>

export const AreaSummaryList = AreaSummary.array()
export type AreaSummaryList = z.infer<typeof AreaSummaryList>
